export default "__VITE_ASSET__GwsSGwCQ__"